import { IOnInit, IWindowService } from "angular";
import { ColDef } from "../../../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../../../records/grids/controller";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../../records/server/query";
import { MachineConfiguration } from "../../../../models/machineConfiguration";
import { ProgressiveDefinition } from "../../../../models/progressiveDefinition";

export const ProgressiveDetailMachinesComponentControllerGridId = Symbol(
  "main.machines.progressives.detail.machines"
);

export class ProgressivesDetailMachinesComponentController implements IOnInit {
  static $inject = [
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$window",
  ];

  defaultQuery: IQuery = {};
  readonly progressiveDefinition!: ProgressiveDefinition;
  readonly gridSettings: IGridSettings;

  readonly additionalColumns: ColDef[];

  constructor(
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly $window: IWindowService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      ProgressiveDetailMachinesComponentControllerGridId
    );

    this.additionalColumns = [
      columnDefinitionService.getCommandColDef({
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        name: "view",
      }),
    ];
  }

  $onInit() {
    this.defaultQuery = {
      ProgressiveDefinitionId: this.progressiveDefinition.Id,
    };
  }

  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  onItemCommand(args: IRowCommandEventArgs<MachineConfiguration>) {
    switch (args.commandName) {
      case "view":
        this.$window.open(
          `/machines/${args.data.MachineId}/configurations`,
          "machineInfo"
        );
    }
  }
}
